import { documentService } from '../../helpers/services/document.service';
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const DOCUMENT_MODULE = 'document'; 

// define action 
export const GET_ALL_DOCUMENTS = 'getAllDocuments';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_DOCUMENTS_REQUEST = "getAllDocuments";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_DOCUMENTS]({ commit }, { filter }) {
        documentService
            .getAllDocuments(filter)
            .then(
                (result) => {
                    commit(GET_ALL_DOCUMENTS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "AI-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_DOCUMENTS_REQUEST](state, data) {
        let d = data.data

        state.list.data = d.map((o) => {
            return {
               uuid: o.uuid,
                name: o.name,
                lrmp: o.lrmp,
                referenceNumber: o.reference_number,
                dor: o.dor,
                expiredDate: o.expired_date,
                remark: o.remark,
                dossierSubmissionDate: o.dossier_submission_date,
                approvalDate: o.approval_date,
                isRegisterCert: o.is_registration_certificated,
                isActive: o.is_active,
                shelfLifeProduction: o.shelf_life_production,
                brand: o.brand,
                form: o.form,
                class: o.class,
                moa: o.moa,
                status: o.status,
                type: o.type,
                purpose: o.purpose,
                productAI: o.rnd_product_ai,
                productSource: o.rnd_product_source,
                productQuery: o.rnd_product_query,
                product: o.rnd_product,
                productPrinterProof: o.rnd_product_printer_proof,
                productPayment: o.rnd_product_payment,
                productLabel: o.rnd_product_label,
                productRegisterCert: o.rnd_product_register_certification,
                productSNS: o.rnd_product_sns,
                productRecommendation: o.rnd_product_recommendation,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        }); 
    },
}


